// import React from "react";
// import "./Zadusnice.scss";
// import { NavLink } from "react-router-dom";

// export default function Zadusnice() {
//   return (
//     <div className="zadusnice">
//       <table>
//         <thead>
//           <tr>
//             <th colspan="2">Zadušnice u 2025. godini</th>
//           </tr>
//         </thead>
//         <tbody>
//           <tr>
//             <td>22. februar</td>
//             <td>
//               <NavLink to="/crkveni-kalendar/2025/februar/">Zimske</NavLink>
//             </td>
//           </tr>
//           <tr>
//             <td>7. jun</td>
//             <td>
//               <NavLink to="/crkveni-kalendar/2025/jun/">Letnje</NavLink>
//             </td>
//           </tr>
//           <tr>
//             <td>11. oktobar</td>
//             <td>
//               <NavLink to="/crkveni-kalendar/2025/oktobar/">Miholjske</NavLink>
//             </td>
//           </tr>
//           <tr>
//             <td>1. novembar</td>
//             <td>
//               <NavLink to="/crkveni-kalendar/2025/novembar/">Mitrovske (jesenje)</NavLink>
//             </td>
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// }
// import React from "react";
// import "./Zadusnice.scss";
// import {
//   calendarYears,
//   zadusniceName,
// } from "../Calendar/calendar-data/calendar-data.js";
// import { monthSerb } from "../../shared/shared.js";
// import { useIdContext } from "../../shared/IdProvider";
// import { Link } from "react-router-dom";

// export default function Zadusnice({ setYear }) {
//   // console.log("TEST1", setYear);

//   const { slug, currentDate } = useIdContext();
//   // console.log("");

//   // let currentYear = slug || currentDate.getFullYear();
//   let currentYear = setYear || slug || currentDate.getFullYear();
//   let yearIndex = calendarYears[0].item_list.findIndex(
//     (item) => item.title == currentYear
//   );

//   return (
//     <div className="zadusnice">
//       <table>
//         <thead>
//           <tr>
//             <th colSpan="2">
//               <h2>{`ZADUŠNICE u ${currentYear}. godini`}</h2>
//             </th>
//           </tr>
//         </thead>
//         <tbody>
//           {calendarYears[0].item_list[yearIndex].zadusnice.map(
//             (item, index) => {
//               return (
//                 <tr key={index}>
//                   <td>
//                     <h3>
//                       <Link to={`/${currentYear}/${monthSerb[item[0]]}/`}>
//                         {zadusniceName[index]}
//                       </Link>
//                     </h3>
//                   </td>
//                   <td>{item[1] + ". " + monthSerb[item[0]]}</td>
//                 </tr>
//               );
//             }
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// }
import "./Zadusnice.scss";
// import { calendarYears } from "../../Calendar/calendar-data/calendar-data.js";
import { calendarYears } from "../Calendar/calendar-data/calendar-data.js";
// import { monthSerb } from "../../../shared/shared.js";
import { monthSerb } from "../../shared/shared.js";
import { useIdContext } from "../../shared/IdProvider.js";
import { Link } from "react-router-dom";

export default function Zadusnice({ setYear, boxTitle, data }) {
  const { slug, currentDate } = useIdContext();
  let currentYear = setYear || slug || currentDate.getFullYear();
  let yearIndex = calendarYears[0].item_list.findIndex(
    (item) => item.title == currentYear
  );
  let zadusniceDate = calendarYears[0].item_list[yearIndex];

  return (
    <div className="zadusnice">
      <table>
        <thead>
          <tr>
            <th colSpan="2">
              <h2>{boxTitle}</h2>
            </th>
          </tr>
        </thead>
        <tbody>
          {zadusniceDate.tableNum.map((item, index) => {
            return (
              <tr key={index}>
                <td>
                  <h3>
                    <Link to={`/${currentYear}/${monthSerb[item[0]]}/`}>
                      {/* {zadusniceName[index]} */}
                      {data.zadusnice[index].charAt(0).toUpperCase() +
                        data.zadusnice[index].slice(1)}
                    </Link>
                  </h3>
                </td>
                <td>{item[1] + ". " + monthSerb[item[0]]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
